import { http } from './httpClient'
import type { AppConfig } from './types'

export const configApi = {
  /** Public endpoint — no auth required, safe to call before login. */
  get: () => http.get<AppConfig>('/api/config/', { silent: true }),
}
